import { Component, Input, OnInit } from '@angular/core'

@Component({
  selector: 'lin-dashboard-ratio-periods',
  template: `
    @if (ratioPeriods !== 0) {
      <mat-icon [svgIcon]="getIcon()"></mat-icon>
    }
    {{ 'ABBREVIATIONS.PERCENT' | translate: { value: (ratioPeriods | number: '1.0-1') || 0 } }}
  `,
  styles: [
    `
      :host {
        display: flex;
        align-items: center;
        font-weight: var(--font-weight-medium);
        margin-left: 5px;
      }
    `,
  ],
  standalone: false,
})
export class DashboardRatioPeriodsComponent implements OnInit {
  @Input() currentPeriod: number
  @Input() previousPeriod: number
  ratioPeriods: number

  ngOnInit() {
    this.ratioPeriods = (this.currentPeriod * 100) / this.previousPeriod - 100
  }

  getIcon(): string {
    return this.ratioPeriods > 0 ? 'arrow_upward' : 'arrow_downward'
  }
}
